import { render } from "./Loading.vue?vue&type=template&id=5f77bd3d&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=5f77bd3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f77bd3d"],['__file',"src/views/components/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f77bd3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f77bd3d', __exports__)) {
    api.reload('5f77bd3d', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=5f77bd3d&scoped=true", () => {
    api.rerender('5f77bd3d', render)
  })

}


export default __exports__